export const GRIDS_AND_LAYOUT_LOCAL_STORAGE_KEY =
  'inspector_grids_and_layouts_by_docs'

/**
 * Arbitrary limit for the number of documents for which we store the settings in local storage.
 */
export const LOCAL_STORAGE_MAX_DOCUMENTS = 100

/**
 * How many documents to remove when we consider we have too many documents in local storage.
 */
export const NUMBER_DOCS_TO_REMOVE = 10
